//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { InvoiceStatusUpdateItem } from './InvoiceStatusUpdateItem';
import { InvoiceEmailInputItem } from './InvoiceEmailInputItem';
import { InvoiceArchiveStatusUpdateItem } from './InvoiceArchiveStatusUpdateItem';

export class BatchInvoiceUpdateItem extends ItemBase {
    StatusUpdateItems: InvoiceStatusUpdateItem[] = [];
    EmailItems: InvoiceEmailInputItem[] = [];
    DeleteInvoiceIDs: string[] = [];
    ArchiveStatusUpdateItems: InvoiceArchiveStatusUpdateItem[] = [];

    constructor(initializer?: Partial<BatchInvoiceUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "BatchInvoiceUpdateItem";
}
